import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Tooltip } from "primereact/tooltip";

import { CalendarField } from "../../../helpers";

import { getDateString, numberConversion, round } from "../../../utils";

import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";

import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { getPIInvoicesBookingStatus } from "../../../services/api/invoiceBooking";


const PIInvoiceBookingDashboard = (props) => {
    const now = new Date()
    now.setDate(now.getDate() - 1)

    const [bookedDate, setBookedDate] = useState(now)
    const [isBookedDateEditable, setIsBookedDateEditable] = useState(false)
    const [piInvoicesBookingStatus, setPIInvoicesBookingStatus] = useState({})
    const [isBookingStatusLoading, setIsBookingStatusLoading] = useState(false)

    const userDetails = useSelector((state) => state.userDetails)
    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)

    const dispatch = useDispatch()

    useEffect(() => {
        getPIInvoicesBookingStatusData(bookedDate)
    }, [])

    const getPIInvoicesBookingStatusData = async (bookedDate) => {
        setIsBookingStatusLoading(true)
        let bookedAt = new Date(bookedDate)
        const piInvoicesBookingStatusRes = await getPIInvoicesBookingStatus({ bookedAt: bookedAt })
        if (piInvoicesBookingStatusRes.failure) {
            setIsBookingStatusLoading(false)
            dispatch(raiseToast({ severity: 'error', summary: 'Booking Statuses', detail: piInvoicesBookingStatusRes.data.error, life: 3000 }))
        }
        let statusData = piInvoicesBookingStatusRes.data?.length ? piInvoicesBookingStatusRes.data[0] : {}
        setPIInvoicesBookingStatus(statusData)
        setIsBookingStatusLoading(false)
    }

    const handleSaveBookedDate = async () => {
        setIsBookedDateEditable(false)
        await getPIInvoicesBookingStatusData(bookedDate)
    }

    const handleBookedDate = (e) => {
        let date = new Date(e.value)
        setBookedDate(date)
    }


    return (
        <div className="flex ml-2 mb-2 mobile-display-container" style={{ width: "" }}>
            <div className="flex flex-row justify-between items-center mobile-display-container">
                <div className="flex flex-column md:flex-row gap-2 mobile-display-container">
                    <div className="flex flex-column p-0 m-0 mt-2" style={{ width: '', height: 'px' }}>
                        <div className="flex col-12 lg:mb-0 p-0 align-content-center ml-1 warehouse-field">
                            <div className="p-0 warehouse-dropdown">
                                <CalendarField name="bookedDate" labelText="Booked Date: " placeholder={"Please Select"} value={bookedDate} onChange={(e) => handleBookedDate(e)} disabled={!isBookedDateEditable} />
                            </div>
                            <div className="mt-3" style={{ cursor: 'pointer' }}>
                                {
                                    isBookedDateEditable ?
                                        <i className="pi pi-save pl-2 mt-2" style={{ fontSize: '1.0rem', cursor: "pointer" }} onClick={() => handleSaveBookedDate()} />
                                        :
                                        <i className="pi pi-file-edit pl-2 mt-2" style={{ fontSize: '1.0rem', cursor: "pointer" }} onClick={() => setIsBookedDateEditable(true)} />
                                }
                            </div>
                        </div>
                    </div>
                    <div className="booking-status-cards-container">
                        <div className="booking-status-box flex-1 p-2 followup-status-card custom-tooltip-booked-invoices" >
                            <h3 className="font-bold text-center mb-1 text-gray-700 text-xs m-0" >
                                Booked Invoices:
                                <br />
                            </h3>
                            {isBookingStatusLoading ?
                                <i className="pi pi-spin pi-spinner text-sm" style={{ fontSize: '2rem' }}></i>
                                :
                                <span className="test-xs font-semibold text-gray-600">{piInvoicesBookingStatus.totalSellerPIPunches ? numberConversion(piInvoicesBookingStatus.totalSellerPIPunches) : '0'}</span>
                            }
                            <Tooltip target={`.custom-tooltip-booked-invoices`} position="top" autoHide>
                                {`No of Invoices booked on ${bookedDate ? getDateString(bookedDate) : '-'}`}
                            </Tooltip>
                        </div>
                        <div className="booking-status-box flex-1 p-2 grn-card custom-tooltip-total-invoice-amount">
                            <h3 className="font-bold text-center mb-1 text-gray-700 text-xs m-0">
                                Total Invoice Amount:
                                <br />
                            </h3>
                            {isBookingStatusLoading ?
                                <i className="pi pi-spin pi-spinner text-sm" style={{ fontSize: '2rem' }}></i>
                                :
                                <span className="test-xs font-semibold text-gray-600">{pmCompanyConfig.currencySymbol} {piInvoicesBookingStatus.totalPIInvoiceAmount ? numberConversion(round(piInvoicesBookingStatus.totalPIInvoiceAmount, 2)) : '0'}</span>
                            }
                            <Tooltip target={`.custom-tooltip-total-invoice-amount`} position="top" autoHide>
                                {`Total amount of booked invoices on ${bookedDate ? getDateString(bookedDate) : '-'}`}
                            </Tooltip>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PIInvoiceBookingDashboard